'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPlaceholder = exports.getText = exports.parseText = undefined;

var _ramda = require('ramda');

var _languages = require('../constants/languages');

var parseText = exports.parseText = function parseText() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var _ref = arguments[1];
    var baseUrl = _ref.baseUrl,
        _ref$baseUrlParams = _ref.baseUrlParams,
        baseUrlParams = _ref$baseUrlParams === undefined ? '' : _ref$baseUrlParams;

    return baseUrl ? text.replace(/src="(.+?)"/g, 'src="' + baseUrl + '$1' + baseUrlParams + '"').replace(/href="(.+?)"/g, 'href="' + baseUrl + '$1' + baseUrlParams + '"') : text;
};

var getText = exports.getText = function getText(item, language) {
    var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
    return (0, _ramda.path)([prop, language], item) || (0, _ramda.path)([prop, _languages.RUS], item);
};

var getPlaceholder = exports.getPlaceholder = function getPlaceholder(text) {
    return ('' + (text || '')).replace(/<br\s*[/]?>/gi, "\n");
};